import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { errorMessage, unwrap } from 'api/call'
import {
  getMessagesBackoffice,
  type MessagesBackofficeMessage,
  type MessagesBackofficeResponse,
} from 'api/generated'
import { toast } from 'sonner'

export const fetchMessages = createAsyncThunk<
  MessagesBackofficeResponse,
  number,
  { rejectValue: string }
>('messages/fetchMessages', async (page, { rejectWithValue }) => {
  try {
    return await unwrap(getMessagesBackoffice({ query: { page } }))
  } catch (error) {
    return rejectWithValue(
      errorMessage(error, 'Errore nel caricamento dei messaggi.')
    )
  }
})

export const messagesSlice = createSlice({
  name: 'messages',
  initialState: {
    messagesList: [] as MessagesBackofficeMessage[],
    loading: false,
    page: 1,
    totalPages: 0,
    totalCount: 0,
    error: null as string | null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchMessages.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(fetchMessages.fulfilled, (state, action) => {
      state.loading = false
      state.messagesList = action.payload.messages
      state.page = action.payload.meta.current_page
      state.totalPages = action.payload.meta.total_pages
      state.totalCount = action.payload.meta.total_count
    })
    builder.addCase(fetchMessages.rejected, (state, action) => {
      state.loading = false
      state.error = action.payload || 'Impossibile caricare i messaggi'
      toast.error('Errore nel caricamento dei messaggi')
    })
  },
})

export const messagesReducer = messagesSlice.reducer
